import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../core/services/contact-us.service';

@Component({
  selector: 'app-careers',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './careers.component.html',
  styleUrl: './careers.component.css'
})
export class CareersComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  form: FormGroup;

  constructor(private fb: FormBuilder, private contactUsService: ContactUsService) {}

  get contentLabels() { return this.contactUsService.contentLabels; }

  ngOnInit() {
    this.form = this.fb.group({});
    this.formReady.emit(this.form);
  }


}
